import React from 'react';
import { StyleSheet, View, Text, Image } from 'react-native';

import IMAGES from 'shared/constants/images';

const ChangePhoneSuccess = () => {
  return (
    <>
      <View style={style.root}>
        <View style={style.imageContainer}>
          <Image source={{ uri: IMAGES.success }} style={style.imageStyle} />
        </View>
        <View style={style.spacer} />
      </View>
      <Text style={style.textTitle}>携帯電話番号の変更が完了しました。</Text>
    </>
  );
};

const style = StyleSheet.create({
  root: {
    flexGrow: 1,
    justifyContent: 'center',
  },
  textTitle: {
    fontSize: 28,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  spacer: {
    marginBottom: 5,
  },
  imageContainer: {
    alignItems: 'center',
  },
  imageStyle: {
    width: '100%',
    aspectRatio: 1,
  },
});

export default ChangePhoneSuccess;
